import moment from 'moment';
import { deleteAnnouncement, updateAnnouncements } from '../../../../../../actions/appsMoreAction'
import { onDeletePop, SOCKET_CONNECTION, TOAST_ERROR, TOAST_LOADING, TOAST_SUCCESS } from '../../../../../../utils';
import { closePricingModal } from '../../../../../../utils/close_modal';
import { refreshThemes } from '../../../../../../actions/firstRunAction';
import { useDispatch } from 'react-redux';
import { MediaBaseUrl } from '../../../../../../actions/api';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '../../../../../CommonComponents/AssetsHelper';

function AnnouncementsList({ announcementsListData, announcementsStatus, setItemIndex, onHide }) {
    const dispatch = useDispatch();

    const delete_Announcement = (id) => {
        onDeletePop(() => {
            TOAST_LOADING()
            deleteAnnouncement(id).then((res) => {
                const { responseCode, syncId } = res.data
                if (responseCode == 200) {
                    TOAST_SUCCESS("Announcement Deleted Successfully.");
                    if(syncId) SOCKET_CONNECTION.emit('wallsuperrefresh', { 'wallId': localStorage.getItem('wallId'), sync: syncId });
                    closePricingModal(dispatch);
                    dispatch(refreshThemes());
                    onHide()
                }
            }).catch(res => {
                TOAST_ERROR(res.message)
                onHide()
            })
        })
    }
    const onUpdateStatus = (id, value) => {
        TOAST_LOADING()
        updateAnnouncements(id, { status: value ? '1' : '0' }).then(res => {
            const { responseCode, syncId } = res.data
            if (responseCode == 200) {
                TOAST_SUCCESS("Status Update Successfully.");
                closePricingModal(dispatch);
                if(syncId) SOCKET_CONNECTION.emit('wallsuperrefresh', { 'wallId': localStorage.getItem('wallId'), sync: syncId });
                dispatch(refreshThemes());
                onHide()
            }
        }).catch(res => {
            TOAST_ERROR(res.message)
            onHide()
        })
    }
    return (
        <>
            {announcementsListData && announcementsListData.length ? <>
                <div className='modal-body'>
                    <div className="anouncementList">
                        <div className="table-scrollable">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Message</th>
                                        <th>Every</th>
                                        <th>Status</th>
                                        <th>Start at</th>
                                        <th>End at</th>
                                        <th className="text-center">Actions</th>
                                    </tr>
                                </thead>
                                {announcementsListData.map((item, index) => <tbody>
                                    <tr>
                                        <td className="imgMessage">
                                            {item.mediaFile ? <img width="50" src={item.mediaFile} style={{ marginRight: '5px' }} /> : `${item.description}...`}
                                        </td>
                                        <td>
                                            {item.every == 0 ? 'Once' : `${item.every} Min`}
                                        </td>

                                        <td>
                                            <div className="toggleOnBut">
                                                <span className="switch">
                                                    <label>
                                                        <input className="onoffswitch-checkbox noLoader updateStatus init" type="checkbox" defaultChecked={item.status} value={item.status} onChange={() => onUpdateStatus(item.id, !item.status)} />
                                                        <span></span>
                                                    </label>
                                                </span>
                                            </div>
                                        </td>

                                        <td>{moment(item.showAt).local().format("DD MMM YYYY H:mm")} </td>
                                        <td> {item.endAt ? moment(item.endAt).local().format("DD MMM YYYY H:mm") : `N/A`}
                                        </td>
                                        <td align="center">
                                            <Button variant='link' className='maintainPopUp resetAction popUp editAnncntBtn me-2' onClick={() => {
                                                setItemIndex(index)
                                                announcementsStatus(2)
                                            }}>
                                                <FontAwesomeIcon type={'solid'} icon={'pencil'} iconClass={'fs-6'} />
                                            </Button>
                                            <Button variant='link' className='maintainPopUp resetAction popUp editAnncntBtn' onClick={() => delete_Announcement(item.id)} >
                                                <FontAwesomeIcon type={'solid'} icon={'trash-can'} iconClass={'fs-6'} />
                                            </Button>
                                        </td>
                                    </tr>
                                </tbody>)}
                            </table>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="d-flex align-items-center justify-content-end w-100">
                        <Button variant='primary' onClick={() => announcementsStatus(1)}>Add New</Button>
                    </div>
                </div>
            </> :
                <div className="text-center" >
                    <div className="spacer10px"></div>
                    <img src={`${MediaBaseUrl}error/drop-box.svg`} className="img-fluid" height={150} width={200}  alt="Upgrade Plan"/>
                    <p className="commanPeraModal text-dark">Oops! Nothing found</p>
                    <Button variant='primary' onClick={() => announcementsStatus(1)} className='btn btn-primary'>Add Announcement</Button>
                </div>}
        </>

    )
}

export default AnnouncementsList













